import React from 'react';
import type { Pruefstatus } from '../../types';
import { ComplianceStatusBadge } from '../../atoms/ComplianceStatusBadge';
import { PruefstatusAreaCard } from '../PruefstatusAreaCard';
import './PruefstatusDashboard.css';

export interface PruefstatusDashboardProps {
  /** Prüfstatus data with overall status and areas */
  pruefstatus: Pruefstatus;
  /** Callback when an area card is clicked */
  onAreaClick?: (areaId: string) => void;
  /** Optional custom className */
  className?: string;
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const PruefstatusDashboard: React.FC<PruefstatusDashboardProps> = ({
  pruefstatus,
  onAreaClick,
  className = '',
}) => {
  return (
    <div className={`pruefstatus-dashboard ${className}`.trim()}>
      <div className="pruefstatus-dashboard__banner">
        <div className="pruefstatus-dashboard__banner-header">
          <h2 className="pruefstatus-dashboard__title">Prüfstatus</h2>
          <span className="pruefstatus-dashboard__date">
            Stand: {formatDate(pruefstatus.last_updated)}
          </span>
        </div>
        <div className="pruefstatus-dashboard__overall">
          <span className="pruefstatus-dashboard__overall-label">Gesamtstatus:</span>
          <ComplianceStatusBadge status={pruefstatus.overall_status} />
          <span className="pruefstatus-dashboard__overall-text">
            {pruefstatus.overall_label}
          </span>
        </div>
      </div>

      <div className="pruefstatus-dashboard__grid">
        {pruefstatus.areas.map((area) => (
          <PruefstatusAreaCard
            key={area.area_id}
            area={area}
            onClick={onAreaClick}
          />
        ))}
      </div>
    </div>
  );
};

export default PruefstatusDashboard;
